import { ISanityBlockContent } from '@rbi-ctg/menu';
import { IPaymentMethod } from 'state/payment/types';

export enum ScanAndPayViews {
  NO_PAYMENT_METHOD = 'noPaymentMethod',
  INACTIVE = 'inactive',
  ACTIVE = 'active',
}

export interface IScanAndPayTextContent {
  header?: string | null;
  inactiveStateBody?: ISanityBlockContent[];
  noPaymentMethodStateBody?: ISanityBlockContent[];
}

export interface ITHScanAndPayViewProps {
  currentView: ScanAndPayViews;
  isLoading: boolean;
  scanAndPayTextContent: IScanAndPayTextContent;
  nonSelectedPaymentMethods: IPaymentMethod[];
  selectedPaymentMethod?: IPaymentMethod;
  toggleScanAndPay: () => void;
  addPaymentMethodButtonText?: string;
  openAddPaymentMethodModal: () => void;
}

export interface IGetSortedValidPaymentMethods {
  paymentMethods: IPaymentMethod[];
  selectedPaymentMethodId: string;
}
